'use client';

import { usePathname } from 'next/navigation';
import { compile, match } from 'path-to-regexp';
import { ReactNode, useMemo } from 'react';

import {
    GeoContextActions,
    GeoContextActionsValue,
    GeoContextState,
    GeoContextStateValue,
} from './context';

export type GeoRouterProps = {
    children: ReactNode;
    defaultId: string;
    path: string;
};

export function GeoRouter({ children, defaultId, path }: GeoRouterProps) {
    const pathname = usePathname();

    const geoId = useMemo(() => {
        const m = match<{
            geoId: string;
        }>(path)(pathname);

        return m ? m.params.geoId : undefined;
    }, [path, pathname]);

    const state = useMemo<GeoContextStateValue>(
        () => ({
            id: geoId ?? defaultId,
        }),
        [defaultId, geoId]
    );

    const builder = useMemo(() => compile(path), [path]);

    const actions = useMemo<GeoContextActionsValue>(
        () => ({
            changeId: (id: string) => {
                const nextPath = builder({
                    geoId: id,
                });

                global.history.pushState({}, '', nextPath);
            },
        }),
        [builder]
    );

    return (
        <GeoContextActions.Provider value={actions}>
            <GeoContextState.Provider value={state}>
                {children}
            </GeoContextState.Provider>
        </GeoContextActions.Provider>
    );
}
